import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomHttpResponse } from '../../../../classes/http';

export interface Sector {
  sector_id: number;
  sector_number_str: string;
  sector_name?: string;
}

export interface District {
  d_id: number;
  district_name: string;
  city?: {
    ct_id: number;
    ct_name: string;
  };
}

export interface WorkloadDay {
  day: string;
  workload_level: number | { source: string; parsedValue: number };
  total_hours: number;
  busy_hours: number;
}

export interface DayTicketsData {
  day: string;
  connection_tickets: number;
  additional_orders: number;
  local_applications: number;
  global_problems: number;
}

@Injectable({
  providedIn: 'root',
})
export class MainCalendarService {
  constructor(private http: HttpClient) {}

  /**
   * Получить список секторов пользователя
   */
  public getUserSectors(userId: number): Observable<CustomHttpResponse<Sector[]>> {
    return this.http.get<CustomHttpResponse<Sector[]>>(`/admin/users/${userId}/sectors/`);
  }

  /**
   * Получить статистику по участку за день
   */
  public getDayStatistics(sectorId: number, date: string): Observable<CustomHttpResponse<any>> {
    return this.http.get<CustomHttpResponse<any>>(`/sectors/${sectorId}/statistics/day`, { params: { date } });
  }

  /**
   * Получить загруженность участка за месяц
   */
  public getMonthWorkload(sectorId: number, year: number, month: number): Observable<CustomHttpResponse<any>> {
    return this.http.get<CustomHttpResponse<any>>(`/sectors/${sectorId}/workload/month`, {
      params: { year: year.toString(), month: month.toString() },
    });
  }

  /**
   * Получить тепловую карту загруженности по дням
   */
  public getWorkingHeatMap(sectorId: number, startDate: string, endDate: string): Observable<CustomHttpResponse<{ days: WorkloadDay[] }>> {
    return this.http.get<CustomHttpResponse<{ days: WorkloadDay[] }>>(`/sectors/sector/${sectorId}/working_heat_map`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  /**
   * Получить количество заявок по дням
   */
  public getNumberOfTickets(sectorId: number, startDate: string, endDate: string): Observable<CustomHttpResponse<{ days: DayTicketsData[] }>> {
    return this.http.get<CustomHttpResponse<{ days: DayTicketsData[] }>>(`/sectors/sector/${sectorId}/number_of_tickets`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  /**
   * Получить список районов для сектора
   */
  public getDistricts(sectorId: number): Observable<CustomHttpResponse<District[]>> {
    return this.http.get<CustomHttpResponse<District[]>>(`/admin/districts/`, {
      params: { sectors_ids: sectorId.toString() },
    });
  }

  /**
   * Получить тепловую карту загруженности района по дням
   */
  public getDistrictWorkingHeatMap(districtId: number, startDate: string, endDate: string): Observable<CustomHttpResponse<{ days: WorkloadDay[] }>> {
    return this.http.get<CustomHttpResponse<{ days: WorkloadDay[] }>>(`/districts/district/${districtId}/working_heat_map`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  /**
   * Получить количество заявок по дням для района
   */
  public getDistrictNumberOfTickets(districtId: number, startDate: string, endDate: string): Observable<CustomHttpResponse<{ days: DayTicketsData[] }>> {
    return this.http.get<CustomHttpResponse<{ days: DayTicketsData[] }>>(`/districts/district/${districtId}/number_of_tickets`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }
}
